import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { HalResourceNotificationService } from 'core-app/features/hal/services/hal-resource-notification.service';
import {
  WorkPackageNotificationService,
} from 'core-app/features/work-packages/services/notifications/work-package-notification.service';
import {
  QueryParamListenerService,
} from 'core-app/features/work-packages/components/wp-query/query-param-listener.service';
import {
  ToolbarButtonComponentDefinition,
} from 'core-app/features/work-packages/routing/partitioned-query-space-page/partitioned-query-space-page.component';
import {
  WorkPackageViewPageComponent,
} from "core-app/features/work-packages/routing/wp-view-page/wp-view-page.component";
import {
  WorkPackageTimelineButtonComponent,
} from "core-app/features/work-packages/components/wp-buttons/wp-timeline-toggle-button/wp-timeline-toggle-button.component";
import {
  WorkPackageSettingsButtonComponent,
} from "core-app/features/work-packages/components/wp-buttons/wp-settings-button/wp-settings-button.component";
import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';
import { OpTitleService } from 'core-app/core/html/op-title.service';
import {
  WorkPackageViewTimelineService,
} from 'core-app/features/work-packages/routing/wp-view-base/view-services/wp-view-timeline.service';

@Component({
  selector: 'wp-view-page-iframe',
  templateUrl: '../../../../../../../../frontend/src/app/features/work-packages/routing/partitioned-query-space-page/partitioned-query-space-page.component.html',
  styleUrls: [
    // Absolute paths do not work for styleURLs :-(
    '../../../../../../../../frontend/src/app/features/work-packages/routing/partitioned-query-space-page/partitioned-query-space-page.component.sass',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    /** We need to provide the wpNotification service here to get correct save notifications for WP resources */
    { provide: HalResourceNotificationService, useClass: WorkPackageNotificationService },
    QueryParamListenerService,
  ],
})
export class WorkPackageViewPageIframeComponent extends WorkPackageViewPageComponent implements OnInit {
  @InjectField() wpTableTimeline:WorkPackageViewTimelineService;

  toolbarButtonComponents:ToolbarButtonComponentDefinition[] = [
    {
      component: WorkPackageTimelineButtonComponent,
      containerClasses: 'hidden-for-tablet -no-spacing',
    },
    {
      component: WorkPackageSettingsButtonComponent,
    },
  ];

  reloadQuery(queryId:bigint, queryProps:object) {
    this.$state.go('work-packages-iframe', { query_id: queryId, query_props: JSON.stringify(queryProps) });
  }

  dispatchMessage(event:MessageEvent) {
    if (typeof event.data !== 'object' || !event.data) return;

    switch (event.data['action']) {
      case 'RefreshView':
        this.reloadQuery(event.data['query_id'], event.data['query_props']);
        break;
    }
  }

  ngOnInit():void {
    super.ngOnInit();

    window.addEventListener('message', this.dispatchMessage.bind(this));

    this.wpTableTimeline
      .updates$()
      .pipe(
        this.untilDestroyed(),
      )
      .subscribe(() => {
        window.parent.postMessage({ action: 'ZoomLevelChanged', zoomLevel: this.wpTableTimeline.zoomLevel }, '*');
      });
  }
}
